import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { wrap } from 'highcharts';

const data = {
  workedTime: '09:18:00',
  avgActivity: '29%',
  ideaTime: '01:15:00',
  focusTime: '02:45:00',
  unusualInstances: 25,
  classification: {
    core: 70,
    nonCore: 20,
    unproductive: 10,
  },
};

const StatItem = ({ title, value, color }) => (
  <Box sx={{
    width: { xl: '20%', lg: '25%', md: '25%', sm: '20%' },
    borderRight: '1px solid #ddd',
    paddingLeft: { xl: '25px', lg: '9px', md: '9px', sm: '10px' },
    '&:last-of-type': {
      borderRight: 'none',
    },
    '&:nth-of-type(1)': {
      paddingLeft: '0px',
    },
  }}>
    <Typography variant="body2" color="#595959" fontWeight={500} sx={{ fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px' } }}>
      {title}
    </Typography>
    <Typography
      variant="h6"
      sx={{ color: color || '#373737', fontSize: { xl: '18px', lg: '16px', md: '16px', sm: '15px', xs: '15px' }, fontWeight: 500 }}
    >
      {value}
    </Typography>
  </Box>
);

const WorkSummary = () => {
  const { core, nonCore, unproductive } = data.classification;

  return (
    <>
      <Box
        bgcolor="#fff"
        p={2}
        borderRadius="8px"
        boxShadow="0 1px 2px rgba(0,0,0,0.1)"
        gap={0}
        sx={{ overflowX: 'auto' }}
      >
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, md: 7, lg: 7, xl: 8, sm: 12 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <StatItem title="Worked Time" value={data.workedTime} color="#007aff" />
              <StatItem
                title="Avg. Activity"
                value={data.avgActivity}
              />
              <StatItem
                title="Idea Time"
                value={data.ideaTime}
              />
              <StatItem
                title="Avg Focus Time"
                value={data.focusTime}
              />
              <StatItem
                title="Unusual activity"
                value={data.unusualInstances}
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 6, md: 5, lg: 5, xl: 4, sm: 12 }}>

            {/* Classification Bar */}
            <Box >
              <Typography variant="body2" color="#595959" fontWeight={500} sx={{ fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px' } }}>
                Work time classification
              </Typography>

              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                mb={0.5}
                sx={{ flexWrap: 'wrap' }}
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Box width={8} height={8} borderRadius="50%" bgcolor="#00bfff" />
                  <Typography variant="body2" fontSize={12}>70% Core work</Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box width={8} height={8} borderRadius="50%" bgcolor="#7f7fff" />
                  <Typography variant="body2" fontSize={12}>20% Non-core work</Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box width={8} height={8} borderRadius="50%" bgcolor="#a566ff" />
                  <Typography variant="body2" fontSize={12}>10% Unproductive</Typography>
                </Box>
              </Box>

              {/* Segmented Bar */}
              <Box
                display="flex"
                height={12}
                borderRadius={1}
                overflow="hidden"
                bgcolor="#eee"
                gap="2px"

              >
                <Box flex={core} bgcolor="#00bfff" title="Core Work" />
                <Box flex={nonCore} bgcolor="#7f7fff" title="Non-Core Work" />
                <Box flex={unproductive} bgcolor="#a566ff" title="Unproductive" />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>

  );
};

export default WorkSummary;
